import { DataProtectionPageComponent } from './pages/data-protection-page/data-protection-page.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { ImprintPageComponent } from './pages/imprint-page/imprint-page.component';
import { TermsAndConditionsPageComponent } from './pages/terms-and-conditions-page/terms-and-conditions-page.component';
import { ShortPageComponent } from './pages/short-page/short-page.component';
import { filter } from 'rxjs/operators';

const routes: Routes = [
  {
    path: '',
    component: ShortPageComponent,
  },
  {
    path: 'terms',
    component: TermsAndConditionsPageComponent,
  },
  {
    path: 'imprint',
    component: ImprintPageComponent,
  },
  {
    path: 'data-policy',
    component: DataProtectionPageComponent,
  },
  {
    path: '**',
    component: ShortPageComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'disabled',
      useHash: true
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private router: Router) {
    // Store scroll position before refresh
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('scrollPosition', window.scrollY.toString());
    });

    // Handle navigation events
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Reset scroll position on navigation
      window.scrollTo(0, 0);
    });

    // Restore scroll position after refresh
    window.addEventListener('load', () => {
      const scrollPosition = sessionStorage.getItem('scrollPosition');
      if (scrollPosition) {
        window.scrollTo(0, parseInt(scrollPosition));
        sessionStorage.removeItem('scrollPosition');
      }
    });
  }
}
